import * as React from "react";
const SvgFiRrSquareM = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-m_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zM19 6.812V18a1 1 0 1 1-2 0V7.583l-4.142 6.931c-.361.604-1.355.604-1.717 0L6.999 7.588V18a1 1 0 1 1-2 0V6.812c0-.817.479-1.496 1.221-1.73a1.81 1.81 0 0 1 2.032.709l3.747 6.261 3.708-6.201c.501-.721 1.318-1.006 2.071-.77.742.234 1.221.913 1.221 1.73z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-m_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquareM;
